import { ArticleSelectorDialogProps } from 'components/Common/ArticleSelector/ArticleSelectorDialog'
import { AssemblySimplificationDialogProps } from 'components/Common/AssemblySimplification/AssemblySimplificationDialog'
import { WorkingStepsDialogProps } from 'components/ProjectPage/AdditionalWorkingSteps/Dialog/WorkingStepsDialog'
import { RowDetailsDialogProps } from 'components/ProjectPage/BillOfMaterials/Rows/Components/RowDetailsDialog/RowDetailsDialog'
import { IssuesDialogProps } from 'components/ProjectPage/BillOfMaterials/Rows/PartType/IssuesDialog'
import { FinancialDetailsProps } from 'components/ProjectPage/BillOfMaterials/Rows/TargetPrice/FinancialDetailsDialog'
import { BatchEditBomItemsDialogProps } from 'features/BillOfMaterials/BatchEditRowsDialog/BatchEditRowsDialog'
import { CuttingPlanDialogProps } from 'features/BillOfMaterials/MaterialHeader/ActiveCuttingPlanDialog'
import { BomItemDetailsDrawerProps } from 'features/BomItemDetailsDrawer/BomItemDetailsDrawer'
import { ConfirmationDialogProps } from 'features/ConfirmationDialog/ConfirmationDialog'
import { CostPriceDetailsProps } from 'features/CostPriceDetails/CostPriceDetailsDialog'
import { EventLogsDialogProps } from 'features/EventLogs/components/EventLogsDialog'
import { ProjectOperationsProps } from 'features/GeometryLogs/ProjectOperationsLogsDrawer'
import { PurchasingPartDialogProps } from 'features/PurchasingPartDetails/PurchasingPartDetails'
import { SalesRepresentativeDialogProps } from 'features/SalesRepresentative/components/SalesRepresentativeDialog'
import { SupportContactDialogProps } from 'features/SupportContactDialog/SupportContactDialog'
import { Action } from 'typesafe-actions'

export enum ProjectViews {
  SalesView = 0,
  PurchaseView = 1,
  FinancialsView = 2,
  AssemblyHierarchy = 3,
  RoutesView = 4,
  FlatGridView = 5,
  DashboardView = 6,
}

export type ModalTypes =
  | 'ArticleSelector'
  | 'WorkingSteps'
  | 'RowDetails'
  | 'AssemblySimplification'
  | 'IssuesDialog'
  | 'FinancialDetails'
  | 'BomItemDetailsDrawer'
  | 'EventLogs'
  | 'SalesRepresentative'
  | 'SupportContact'
  | 'CostPriceDetails'
  | 'CuttingPlanDetails'
  | 'ConfirmationDialog'
  | 'BatchEditBomItems'
  | 'ProjectOperations'
  | 'PurchasingPartDialog'

export type ModalTypeProps =
  | ArticleSelectorDialogProps
  | WorkingStepsDialogProps
  | RowDetailsDialogProps
  | AssemblySimplificationDialogProps
  | IssuesDialogProps
  | FinancialDetailsProps
  | EventLogsDialogProps
  | SalesRepresentativeDialogProps
  | SupportContactDialogProps
  | CostPriceDetailsProps
  | CuttingPlanDialogProps
  | ConfirmationDialogProps
  | BatchEditBomItemsDialogProps
  | ProjectOperationsProps
  | BomItemDetailsDrawerProps
  | PurchasingPartDialogProps

export type UIState = {
  Modals?: {
    CurrentModal: ModalTypes
    ModalProps: ModalTypeProps
  }
}

export enum UIActionNames {
  UploadProgress = 'ui/update_upload_progress',
  DeleteProgress = 'ui/delete_upload_progress',
  ChangeProjectView = 'ui/change_project_view',
  CollapseAllHeaders = 'ui/collapse_all_headers',
  ExpandAllHeaders = 'ui/expand_all_headers',
  CloseModal = 'CloseModal',
  OpenModal = 'OpenModal',
}

export interface ChangeProjectView extends Action {
  type: UIActionNames.ChangeProjectView
  view: ProjectViews
}

export interface SetUploadProgress extends Action {
  type: UIActionNames.UploadProgress
  operation: string
  progress: number
}

export interface DeleteUploadProgress extends Action {
  type: UIActionNames.DeleteProgress
  operation: string
}

export interface CollapseAllHeaders extends Action {
  type: UIActionNames.CollapseAllHeaders
}

export interface ExpandAllHeaders extends Action {
  type: UIActionNames.ExpandAllHeaders
}

export interface OpenModal extends Action {
  type: UIActionNames.OpenModal
  modalType: ModalTypes
  modalProps: ModalTypeProps
}

export interface CloseModal extends Action {
  type: UIActionNames.CloseModal
}

export type UIActionTypes =
  | SetUploadProgress
  | DeleteUploadProgress
  | ChangeProjectView
  | CollapseAllHeaders
  | ExpandAllHeaders
  | OpenModal
  | CloseModal
